// extracted by mini-css-extract-plugin
module.exports = {"cover":"styles_cover__YDlH4"};